import { useOktaAuth } from "@okta/okta-react";
import { useLocation } from "react-router-dom";
const SecureRoute = ({ children }: { children: JSX.Element }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();
  if (!authState) {
    return <div>Loading...</div>;
  }
  const loggingIn = async () => {
    oktaAuth.signInWithRedirect({
      originalUri: location.pathname + location.search,
    });
  };

  if (!authState.isAuthenticated) {
    // Resetting local storage value so that user login tracking api trigger after login
    localStorage.removeItem("isAuthenticated");
    loggingIn();
    return null;
  }
  return children;
};
export default SecureRoute;
